export default {"src":"/_next/static/media/accordion-1.4c41e3c9.svg","height":390,"width":494,"blurWidth":0,"blurHeight":0};